"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectAsyncCreatable = exports.SelectAsync = exports.SelectCreatable = exports.Select = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("styled-components");
const wl_ui_kit_1 = require("@invent/wl-ui-kit");
const hintColors = {
    success: 'success',
    warning: 'warning',
    error: 'danger',
    info: 'onSurface'
};
function getBorderColor(isFocused, hintType) {
    if (hintType) {
        return (0, wl_ui_kit_1.getColor)(hintColors[hintType]);
    }
    if (isFocused) {
        return (0, wl_ui_kit_1.getColor)('primary');
    }
    return (0, wl_ui_kit_1.getColorShade)('onSurface', 'outline');
}
function generateStyles(theme, size, hintType, prefixIcon, groupPosition) {
    return {
        control(provided, { isFocused, isDisabled }) {
            return Object.assign(Object.assign({}, provided), { color: (0, wl_ui_kit_1.getColor)('onSurface')({ theme }), minHeight: (0, wl_ui_kit_1.getSizeBy)(9, size)({ theme }), borderRadius: (0, wl_ui_kit_1.groupRadius)(groupPosition)({ theme }), borderWidth: 1, backgroundColor: isDisabled
                    ? (0, wl_ui_kit_1.getColorShade)('onSurface', 'hover')({ theme })
                    : (0, wl_ui_kit_1.getColor)('surface')({ theme }), borderColor: getBorderColor(isFocused, hintType)({ theme }), boxShadow: 'none', '&:hover': isFocused || isDisabled || hintType
                    ? {}
                    : {
                        borderColor: (0, wl_ui_kit_1.getColorShade)('onSurface', 'mediumEmphasis')({ theme })
                    } });
        }
    };
}
function selectHoc(Component) {
    // TODO: use T
    return (props) => {
        var _a, _b;
        const theme = (0, styled_components_1.useTheme)();
        const styles = Object.assign(Object.assign({}, generateStyles(
        // @ts-ignore
        theme, (_a = props.size) !== null && _a !== void 0 ? _a : 'medium', props.hintType, props.prefixIcon, props.groupPosition)), ((_b = props.styles) !== null && _b !== void 0 ? _b : {}));
        return react_1.default.createElement(Component, Object.assign({}, props, { styles: styles }));
    };
}
exports.Select = selectHoc(wl_ui_kit_1.Select);
exports.SelectCreatable = selectHoc(wl_ui_kit_1.SelectCreatable);
exports.SelectAsync = selectHoc(wl_ui_kit_1.SelectAsync);
exports.SelectAsyncCreatable = selectHoc(wl_ui_kit_1.SelectAsyncCreatable);
